import { useEffect, useRef } from "react";
import { SHUT_DOWN, SOCIALS } from "../../data/socials";
import classes from "./Menu.module.css";

const MENU_HOTKEYS = new Set(
  SOCIALS.map((item) => item.hotkey).concat(SHUT_DOWN.hotkey)
);

const getHotkey = (event) => {
  const fromKey = event.key?.length === 1 ? event.key.toLowerCase() : "";
  const fromCode = event.code?.startsWith("Key")
    ? event.code.slice(3).toLowerCase()
    : "";
  const fromKeyCode =
    event.keyCode >= 65 && event.keyCode <= 90
      ? String.fromCharCode(event.keyCode).toLowerCase()
      : "";

  if (MENU_HOTKEYS.has(fromKey)) {
    return fromKey;
  }

  if (MENU_HOTKEYS.has(fromCode)) {
    return fromCode;
  }

  if (MENU_HOTKEYS.has(fromKeyCode)) {
    return fromKeyCode;
  }

  return null;
};

const stopHotkey = (event) => {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
};

export const Menu = ({ onClose, ignoreCloseRef }) => {
  const rootRef = useRef(null);

  useEffect(() => {
    const onPointerDown = (event) => {
      const target = event.target;
      if (
        rootRef.current?.contains(target) ||
        ignoreCloseRef?.current?.contains(target)
      ) {
        return;
      }

      onClose(false);
    };

    const onKeyEvent = (event) => {
      if (!event.ctrlKey || event.shiftKey || event.altKey || event.metaKey) {
        return;
      }

      const hotkey = getHotkey(event);
      if (!hotkey) {
        return;
      }

      stopHotkey(event);

      if (event.type !== "keydown") {
        return;
      }

      const link = rootRef.current?.querySelector(`[data-hotkey="${hotkey}"]`);
      link?.click();
    };

    document.addEventListener("pointerdown", onPointerDown, true);
    document.addEventListener("keydown", onKeyEvent, true);
    document.addEventListener("keyup", onKeyEvent, true);
    document.addEventListener("keypress", onKeyEvent, true);

    return () => {
      document.removeEventListener("pointerdown", onPointerDown, true);
      document.removeEventListener("keydown", onKeyEvent, true);
      document.removeEventListener("keyup", onKeyEvent, true);
      document.removeEventListener("keypress", onKeyEvent, true);
    };
  }, [onClose, ignoreCloseRef]);

  return (
    <div className={classes.Menu} ref={rootRef}>
      <div className={classes.container}>
        <div className={classes.win95plank}>
          <p>Socials</p>
        </div>
        <div className={classes.linksMenu}>
          {SOCIALS.map((item) => (
            <div className={classes.menuLink} key={item.href}>
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                data-hotkey={item.hotkey}
              >
                <div className={classes.linkContainer}>
                  <img src={item.img} alt={item.alt} />
                  <div className={classes.linkContainerText}>
                    <p>
                      {item.prefix}
                      <u>{item.underline}</u>
                      {item.rest}
                    </p>
                  </div>
                  <p>►</p>
                </div>
              </a>
            </div>
          ))}

          <hr />

          <div className={classes.menuLink}>
            <a
              href={SHUT_DOWN.href}
              data-hotkey={SHUT_DOWN.hotkey}
              onClick={() => window.close()}
            >
              <div className={classes.linkContainer}>
                <img src={SHUT_DOWN.img} alt={SHUT_DOWN.alt} />
                <div className={classes.linkContainerText}>
                  <p>
                    Sh<u>u</u>t Down...
                  </p>
                </div>
                <p>►</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
